import { render, staticRenderFns } from "./ABMCertificados.vue?vue&type=template&id=6303fd58&"
import script from "./ABMCertificados.vue?vue&type=script&lang=js&"
export * from "./ABMCertificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports